export default function AppDownload() {
  return (
    <section className="bg-gradient-to-r from-[#8B5CF6] to-[#A78BFA] py-4 sm:py-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="text-center sm:text-left">
              <p className="text-white font-bold text-sm sm:text-base">온니잡 앱 다운로드</p>
              <p className="text-white/80 text-xs sm:text-sm">더 빠르고 편리한 퀸알바 찾기</p>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <a 
              href="https://apps.apple.com/kr/app/%EC%98%A8%EB%8B%88%EC%9E%A1-%EC%9D%B5%EB%AA%85-%EC%97%AC%EC%84%B1-%EC%BB%A4%EB%AE%A4%EB%8B%88%ED%8B%B0-%EC%95%8C%EB%B0%94/id6745007770" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-black rounded-lg px-4 py-2.5 hover:bg-gray-900 transition-colors cursor-pointer"
            >
              <i className="ri-apple-fill text-white text-lg sm:text-xl"></i>
              <div className="text-left">
                <p className="text-white/70 text-[10px] leading-tight">Download on the</p>
                <p className="text-white font-semibold text-xs sm:text-sm leading-tight whitespace-nowrap">App Store</p>
              </div>
            </a>
            
            <a 
              href="https://play.google.com/store/apps/details?id=kr.onnyjob.app&hl=ko" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-black rounded-lg px-4 py-2.5 hover:bg-gray-900 transition-colors cursor-pointer"
            >
              <i className="ri-google-play-fill text-white text-lg sm:text-xl"></i>
              <div className="text-left">
                <p className="text-white/70 text-[10px] leading-tight">GET IT ON</p>
                <p className="text-white font-semibold text-xs sm:text-sm leading-tight whitespace-nowrap">Google Play</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
